module.exports = "mat-table {\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/ministers/requests-credential-renovation/requests-credential-renovation.component.scss
// module id = ./src/app/admin/pages/ministers/requests-credential-renovation/requests-credential-renovation.component.scss
// module chunks = main